import { gql } from 'graphql-request'

export const SALVAR_GRUPO_USUARIOS = gql`
  mutation SalvarGrupoUsuariosMutation($grupoUsuarios: GrupoUsuariosInput!) {
    salvarGrupoUsuarios(grupoUsuarios: $grupoUsuarios) {
      id
      nome
    }
  }
`
